import { CHANNEL_MULTIPLIER } from "../../common/constants/pricing";
import { CAMPAIGN_MIN_BUDGET } from "./constants";
import { getCategoryMultiplier } from "../../utils/Helpers";

export const isChannelsRecommendedOnes = ({ recommendedChannels = [], selectedChannels = [] }) => {
  // Gets channel short names
  const recommendedChannelNames = recommendedChannels.map((channel) => channel.channel_short_name);

  // Gets channels selected
  const selectedChannelNames = selectedChannels.map((channel) => channel.channel_short_name);

  // Check if all recommended channel names are present in selected channel names
  const areAllRecommendedChannelsSelected = recommendedChannelNames.every((channel) =>
    selectedChannelNames.includes(channel)
  );

  // Check if all selected channel names are present in recommended channel names
  const areAllSelectedChannelsRecommended = selectedChannelNames.every((channel) =>
    recommendedChannelNames.includes(channel)
  );

  return areAllRecommendedChannelsSelected && areAllSelectedChannelsRecommended;
};

export const isBudgetRecommendedOne = ({ budget, budget_default }) => {
  if (parseInt(budget, 10) === parseInt(budget_default, 10)) {
    return true;
  }

  return false;
};

// Set min budget to CAMPAIGN_MIN_BUDGET
export const getDefaultBudget = ({ jobCategoryId, minBudget = CAMPAIGN_MIN_BUDGET }) => {
  const effectiveMinBudget = Math.max(minBudget, 0);

  const l1Multiplier = getCategoryMultiplier(jobCategoryId);
  const multiplier = CHANNEL_MULTIPLIER * l1Multiplier;

  const budgetDefault = Math.ceil(minBudget * multiplier);
  return Math.max(budgetDefault, effectiveMinBudget);
};

// This function is used to know if the client used the recommended channels and budget
export const clientFollowedRecommendations = ({
  recommendedChannels,
  selectedChannels,
  budget,
  budget_default
}) => {
  const followedChannelRecommendation = isChannelsRecommendedOnes({
    recommendedChannels,
    selectedChannels
  });
  const followedBudgetRecommendation = isBudgetRecommendedOne({ budget, budget_default });

  return {
    followedBudgetRecommendation,
    followedChannelRecommendation
  };
};
